export default __webpack_public_path__ + "static/media/Warlord's Band of Might.ef0c02e1.jpg";